import React from "react";
import LandingSection from "./LandingSection";
import Whatwedo from "./Whatwedo";
import Whatweoffer from "./Whatweoffer";
import OurClients from "./OurClients";
import { Box } from "@mui/material";
import TalktoUs from "../../components/ContactUsForm/TalktoUs";
import OurTeam from "./OurTeam";
import TeamSlider from "../../components/slider/TeamSlider";
import CustomerSlider from "../../components/slider/CustomerSlider";
import CaseStudies from "./CaseStudies";
import { Toaster } from "react-hot-toast";
import { Helmet } from "react-helmet";
import EventPopup from "../../components/Popup/EventPopup";

const Home = () => {
  return (
    <>
      <Helmet>
        <title>Inteliphyle | AI-Powered Advisory Solutions</title>
        <meta
          name="description"
          content="Inteliphyle provides advisory solutions that combine machine intelligence, human expertise, and artificial intelligence to deliver smarter decision-making for businesses worldwide."
        />
      </Helmet>
      <Box
        sx={{
          backgroundColor: "#ecebeb",
        }}
      >
        <LandingSection />
        <EventPopup />
        <Whatwedo />
        <Whatweoffer />
        <CaseStudies />
        <OurClients />
        <CustomerSlider />
        <OurTeam />
        <TeamSlider />
        <TalktoUs />
        <Toaster
          position="bottom-right"
          toastOptions={{
            duration: 3000,
            style: {
              background: "#FFFFFF", // White background
              color: "#1F2128", // Dark text for contrast
              borderRadius: "8px",
              padding: "12px 16px",
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
              border: "1px solid #FF6A00", // Subtle orange border for theme consistency
            },
            success: {
              iconTheme: {
                primary: "#4ADE80", // Green success icon
                secondary: "#FFFFFF",
              },
            },
            error: {
              iconTheme: {
                primary: "#EF4444", // Red error icon
                secondary: "#FFFFFF",
              },
            },
          }}
        />
      </Box>
    </>
  );
};

export default Home;
